<template>
    <div>
        <div class="info-box">
            <div class="info-title"><h3>基本信息</h3><p></p></div>
            <div class="info-main">
                <div class="input-box">
                    <p>年份：</p>
                    <a-input class="input" v-model="info.year" disabled />
                </div>
                <div class="input-box">
                    <p>教师：</p>
                    <a-input class="input" v-model="info.teacherName" disabled />
                </div>
                <div class="input-box">
                    <p>工号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled />
                </div>
                <div class="input-box">
                    <p>部门：</p>
                    <a-input class="input" v-model="info.orgName" disabled />
                </div>
                <div class="input-box">
                    <p>职称：</p>
                    <a-input class="input" v-model="info.technicalTitleName" disabled />
                </div>
                <div class="input-box">
                    <p>人员类别：</p>
                    <a-input class="input" v-model="info.personnelCategory" disabled />
                </div>
                <div class="input-box">
                    <p>进校时间：</p>
                    <a-input class="input" v-model="info.entryDate" disabled />
                </div>
                <div class="input-box">
                    <p>离校时间：</p>
                    <a-input class="input" v-model="info.quitDate" :placeholder="info.quitDate ? '' : '—'" disabled />
                </div>
                <div class="input-box">
                    <p>在岗月份：</p>
                    <a-input class="input" v-model="info.onJobMonths" disabled />
                </div>
            </div>

            <div class="info-title" v-if="showPersonnelCategory"><h3>人员类别</h3><p></p></div>
            <div class="info-main" v-if="showPersonnelCategory">
                <div class="input-box input-box-full">
                    <p>人员类别：</p>
                    <a-input class="input" v-model="info.personnelCategory" disabled />
                </div>
                <div class="input-box" v-if="info.adminRank">
                    <p>行政级别：</p>
                    <a-input class="input" v-model="info.adminRank" disabled />
                </div>
            </div>

            <div class="info-title" v-if="showWorkload"><h3>工作量</h3><p></p></div>
            <div class="info-main" v-if="showWorkload">
                <div class="input-box">
                    <p>工作量最低标准：</p>
                    <a-input-number class="input" v-model="info.minWorkload" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>本科教学工作量：</p>
                    <a-input-number class="input" v-model="info.undergraduateWorkload" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>研究生教学工作量：</p>
                    <a-input-number class="input" v-model="info.masterWorkload" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>科研工作量：</p>
                    <a-input-number class="input" v-model="info.researchWorkload" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>总工作量：</p>
                    <a-input-number class="input" v-model="info.totalWorkload" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>工作量完成情况：</p>
                    <span :class="['completion-tag', completionClass]">{{ info.workloadCompletion || '-' }}</span>
                </div>
            </div>

            <div class="info-title"><h3>奖励明细</h3><p></p></div>
            <div class="info-main">
                <div class="input-box">
                    <p>基础奖励：</p>
                    <a-input-number class="input" v-model="info.baseReward" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>完成工作量奖励：</p>
                    <a-input-number class="input" v-model="info.completionReward" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>基本奖励：</p>
                    <a-input-number class="input" v-model="info.basicReward" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>工作量奖励：</p>
                    <a-input-number class="input" v-model="info.workloadReward" :precision="2" disabled />
                </div>
                <div class="input-box">
                    <p>绩效专项奖励：</p>
                    <a-input-number class="input" v-model="info.performanceReward" :precision="2" disabled />
                </div>
                <div class="input-box total-box">
                    <p>年终奖合计：</p>
                    <span class="total-amount">{{ totalDisplay }}</span>
                </div>
                <div class="input-box input-box-large">
                    <p>备注：</p>
                    <a-textarea class="input" :rows="2" v-model="info.remark" disabled />
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button @click="$router.go(-1)">返回</a-button>
        </div>
    </div>
</template>

<script>
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { info } from '@/baseAPI/yearBonus'

    export default {
        name: 'yearBonusInfo',
        data() {
            return {
                type: 'view',
                info: {
                    id: '',
                    year: null,
                    teacherId: '',
                    teacherName: '',
                    orgCode: '',
                    orgName: '',
                    technicalTitleCode: '',
                    technicalTitleName: '',
                    staffCategoryName: '',
                    entryDate: '',
                    quitDate: '',
                    onJob: true,
                    onJobMonths: 12,
                    personnelCategory: '',
                    adminRank: '',
                    minWorkload: 0,
                    undergraduateWorkload: 0,
                    masterWorkload: 0,
                    researchWorkload: 0,
                    totalWorkload: 0,
                    workloadCompletion: '',
                    baseReward: 0,
                    completionReward: 0,
                    basicReward: 0,
                    workloadReward: 0,
                    performanceReward: 0,
                    totalBonus: 0,
                    remark: '',
                },
            }
        },
        computed: {
            showWorkload() {
                const cat = this.info.personnelCategory
                return !['博士后', '行政人员', '特聘协议人员'].includes(cat)
            },
            showPersonnelCategory() {
                return !!this.info.personnelCategory
            },
            completionClass() {
                const c = this.info.workloadCompletion
                if (c === '超') return 'completion-over'
                if (c === '达') return 'completion-meet'
                if (c === '未完成') return 'completion-fail'
                return ''
            },
            totalDisplay() {
                const t = this.info.totalBonus
                return t != null ? Number(t).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'
            },
        },
        mounted() {
            this.type = this.$route.query.type || 'view'
            if (this.$route.query.id) {
                this.loadInfo()
            }
        },
        methods: {
            /**
             * 加载详情信息
             */
            loadInfo() {
                info(this.$route.query.id).then(res => {
                    this.info = res.data || {}
                }).catch(() => {
                    this.$notification['error']({ message: '错误', description: '加载详情失败' })
                })
            },
        }
    }
</script>

<style scoped>
.info-box { margin-bottom: 2rem; }
.info-title { position: relative; line-height: 3rem; }
.info-title h3 { font-size: 1.2rem; font-weight: bold; letter-spacing: 2px; padding-left: 10px; color: #245086; }
.info-title p { position: absolute; left: 0; bottom: 0; width: 50%; height: 3px; background-image: linear-gradient(to right, #245086, rgba(36,80,134,0)); }
.info-main { display: flex; flex-wrap: wrap; margin-top: 1.5rem; }
.info-main .input-box { width: 33%; display: flex; line-height: 32px; margin-bottom: 1.5rem; position: relative; }
.info-main .input-box-large { width: 99%; }
.info-main .input-box-full { width: 99%; }
.info-main .input-box p { width: 10rem; text-align: right; flex-shrink: 0; }
.info-main .input-box .input { width: calc(100% - 10rem); }
.tag-info { color: #1890ff; font-size: 0.9rem; line-height: 32px; }
.on-job-yes { color: #52c41a; font-weight: bold; line-height: 32px; }
.on-job-no { color: #f5222d; font-weight: bold; line-height: 32px; }
.category-radio-group { line-height: 32px; }
.category-radio-group >>> .ant-radio-button-wrapper { margin-right: 4px; margin-bottom: 4px; }
.completion-tag { display: inline-block; padding: 0 12px; border-radius: 4px; font-weight: bold; line-height: 32px; }
.completion-over { color: #52c41a; background: #f6ffed; border: 1px solid #b7eb8f; }
.completion-meet { color: #1890ff; background: #e6f7ff; border: 1px solid #91d5ff; }
.completion-fail { color: #f5222d; background: #fff1f0; border: 1px solid #ffa39e; }
.total-box { width: 99%; }
.total-amount { font-size: 1.5rem; font-weight: bold; color: #245086; line-height: 32px; margin-left: 0.5rem; }
.btn-box { text-align: center; }
.btn-box .ant-btn { margin: 0 1rem; }
.input >>> .ant-input[disabled],
.ant-input[disabled], .ant-select-disabled, .ant-input-number-disabled { color: rgba(0,0,0,0.65); background-color: transparent; }
.ant-select-disabled >>> .ant-select-selection { background-color: transparent; }
</style>
